<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  card: {type: Object, required: true},

  // keep any other optional toggles you already had if you still use them
  linkWholeBillboard: {type: Boolean, default: true},
})

/** convenience accessor */
const settings = computed(() => props.card?.settings ?? {})

/** exactly what you asked for: settings.color & settings.centered
 *  (with a fallback to headlineColor for older data) */
const colorClass = computed(() =>
  String(settings.value.color || settings.value.headlineColor || '').trim()
)
const isCentered = computed(() => !!settings.value.centered)

/** media helpers */
const mediaByField = (field) => {
  const list = Array.isArray(props.card?.media) ? props.card.media : []
  return list.find(m => (m?.field || '').toLowerCase() === field) || null
}
const image = computed(() =>
  mediaByField('image') || mediaByField('image_tablet') || mediaByField('image_mobile')
)
const video = computed(() => mediaByField('video'))

/** href is already resolved on the backend */
const href = computed(() => {
  const raw = props.card?.link
  return (typeof raw === 'string' && raw.trim()) ? raw : null
})

/** classes */
const rootClasses = computed(() => ([
  'content-item',
  'module-teaser-v2',
  '-in-viewport',
  isCentered.value ? '-text-center' : ''
].filter(Boolean).join(' ')))

const contentClasses = computed(() => ([
  'content__content',
  colorClass.value
].filter(Boolean).join(' ')))
</script>

<template>
  <div :class="rootClasses" data-viewport-offset="50%">
    <div
      v-if="image && !video"
      class="teaser_background"
      role="img"
      :aria-label="image.alt || card.title || ''"
      :style="`background:url('${image.url}') no-repeat center/cover`"
    />
    <div v-if="video" class="item__video">
      <div class="video-wrapper">
        <video playsinline muted autoplay loop>
          <source :src="video.url" type="video/mp4"/>
        </video>
      </div>
    </div>
    <component
      :is="linkWholeBillboard && href ? 'a' : 'div'"
      :href="linkWholeBillboard && href ? href : '#'"
      class="teaser__content"
    >
      <div class="content__wrap -max-width-limited">
        <div :class="contentClasses">
          <span v-if="card.subheader" class="hl heading gamma sl" v-html="card.subheader"/>
          <span class="hl heading beta" v-html="card.title"/>
          <div v-if="href && card.linktext" class="content__link">
            <div v-if="linkWholeBillboard" class="-btn-alpha">{{ card.linktext }}</div>
            <a v-else class="-btn-alpha" :href="href">{{ card.linktext }}</a>
          </div>
        </div>
      </div>
    </component>
  </div>
</template>
